"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _currencyInputModule = _interopRequireDefault(require("./currencyInput.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var defaultMenuOptions = [{
  sign: '£',
  code: 'GBP'
}, {
  sign: '€',
  code: 'EUR'
}];
var defaultSelectedOption = {
  sign: '£',
  code: 'GBP'
};
/**
 * Hook that alerts clicks outside of the passed ref
 */

var useOutside = function useOutside(ref, handleOutsideClick) {
  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target) && handleOutsideClick) {
        handleOutsideClick();
      }
    } // Bind the event listener


    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, handleOutsideClick]);
};

var CurrencyInput = function CurrencyInput(props) {
  var id = props.id,
      onChange = props.onChange,
      value = props.value,
      name = props.name,
      disabled = props.disabled,
      required = props.required,
      onBlur = props.onBlur,
      menuOptions = props.menuOptions,
      handleOptionSelect = props.handleOptionSelect,
      selectedCurrency = props.selectedCurrency,
      autoComplete = props.autoComplete,
      disabledDropdown = props.disabledDropdown;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var wrapperRef = (0, _react.useRef)(null);
  useOutside(wrapperRef, function () {
    if (isOpen) {
      setIsOpen(false);
    }
  });
  var iterableMenuOptions = menuOptions ? menuOptions : defaultMenuOptions;
  var selectedOption = selectedCurrency && selectedCurrency.code && selectedCurrency.sign ? selectedCurrency : defaultSelectedOption;

  var handleButtonClick = function handleButtonClick() {
    setIsOpen(!isOpen);
  };

  var createOptionHandler = function createOptionHandler(option) {
    return function () {
      if (handleOptionSelect) {
        handleOptionSelect(option);
      }
    };
  };

  return _react.default.createElement("div", {
    id: id ? id : null,
    className: _currencyInputModule.default['input-group']
  }, _react.default.createElement("input", {
    id: id ? "".concat(id, "_input") : null,
    autoComplete: autoComplete ? autoComplete : "",
    className: _currencyInputModule.default["form-control"],
    value: value,
    name: name,
    onChange: onChange,
    onBlur: onBlur,
    disabled: disabled,
    required: required
  }), _react.default.createElement("div", {
    id: id ? "".concat(id, "_btn") : null,
    className: _currencyInputModule.default['input-group-btn'],
    ref: wrapperRef,
    onClick: handleButtonClick
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_btn_picker") : null,
    className: disabledDropdown ? (0, _classnames.default)(_currencyInputModule.default['btn'], _currencyInputModule.default['buttonPicker']) : (0, _classnames.default)(_currencyInputModule.default['btn'], _currencyInputModule.default['btn-default'], _currencyInputModule.default['buttonPicker']),
    tabIndex: -1,
    disabled: disabledDropdown
  }, selectedOption.sign, _react.default.createElement("span", {
    id: id ? "".concat(id, "_btn_caret") : null,
    className: _currencyInputModule.default['caret']
  }), isOpen && !disabledDropdown && _react.default.createElement("ul", {
    id: id ? "".concat(id, "_dropdown_menu") : null,
    className: (0, _classnames.default)(_currencyInputModule.default['dropdown-menu'], _currencyInputModule.default['dropdown-menu-right']),
    style: {
      display: 'inline'
    }
  }, iterableMenuOptions.map(function (option, index) {
    return _react.default.createElement("li", {
      id: id ? "".concat(id, "_dropdown_item_").concat(index) : null,
      key: index,
      onClick: createOptionHandler(option)
    }, _react.default.createElement("a", {
      id: id ? "".concat(id, "_dropdown_item_").concat(option.code) : null
    }, "".concat(option.code, " ( ").concat(option.sign, " )")));
  })))));
};

CurrencyInput.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text that enables or disable the browser to offer autocompletion */
  autoComplete: _propTypes.default.string,

  /** Callback invoked on blur. An event argument will be available. eg: (evt) => {} */
  onBlur: _propTypes.default.func,

  /** Callback invoked when the input changes.It will be passed with an event argument as an argument.eg: (evt) =>{} */
  onChange: _propTypes.default.func.isRequired,

  /** The name attribute of the element */
  name: _propTypes.default.string.isRequired,

  /** The value of the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,

  /** Boolean indicating if the component is disabled  */
  disabled: _propTypes.default.bool,

  /** Boolean indicating if the component is required  */
  required: _propTypes.default.bool,

  /** Callback invoked when the currency changes.It will be passed with the selected option-currency as an arg.eg: (option) =>{} */
  handleOptionSelect: _propTypes.default.func.isRequired,

  /** The selected currency, it defaults to pounds */
  selectedCurrency: _propTypes.default.shape({
    sign: _propTypes.default.string,
    code: _propTypes.default.string
  }),

  /** array of currency options */
  menuOptions: _propTypes.default.array
};
var _default = CurrencyInput;
exports.default = _default;